<template>
    <main class="privacy_container">
        <h1>{{ $t('privacy.title') }}</h1>
            <div class="privacyContainer">
            <p class="privacyTitles">{{ $t('privacy.titleParagraph1') }}</p>
            <p>{{ $t('privacy.paragraph1A') }}</p>
            <p>{{ $t('privacy.paragraph1B') }}</p>

            <p class="privacyTitles">{{ $t('privacy.titleParagraph2') }}</p>
            <p>{{ $t('privacy.paragraph2') }}</p>
            <p class="privacyNoMargin"> GMA LOGISTICS </p>
            <p class="privacyNoMargin"> 501 avenue de la couronne des prés,78680 Epône</p>
            <p class="privacyNoMargin"> contact@gma-logistics.com </p>
 
            <p class="privacyTitles">{{ $t('privacy.titleParagraph3') }}</p>
            <p>{{ $t('privacy.paragraph3') }}</p>
            <ul>
                <li>
                    <span>{{ $t('privacy.paragraph3Bullet1A') }}</span>
                    <span>{{ $t('privacy.paragraph3Bullet1B') }}</span>    
                </li>
                <li>
                    <span>{{ $t('privacy.paragraph3Bulle2A') }}</span>
                    <span>{{ $t('privacy.paragraph3Bullet2B') }}</span>    
                </li>
                <li>
                    <span>{{ $t('privacy.paragraph3Bullet3A') }}</span>
                    <span>{{ $t('privacy.paragraph3Bullet3B') }}</span>    
                </li>
            </ul>
            <p>{{ $t('privacy.paragraph3B') }}</p>
            <ul>
                <li>{{ $t('privacy.paragraph3Bullet4') }}</li>
                <li>{{ $t('privacy.paragraph3Bullet5') }}</li>
                <li>{{ $t('privacy.paragraph3Bullet6') }}</li>
            </ul>

            <p class="privacyTitles">{{ $t('privacy.titleParagraph4') }}</p>
            <p>{{ $t('privacy.paragraph4') }}</p>
            <ul>
                <li>{{ $t('privacy.paragraph4Bullet1') }}</li>
                <li>{{ $t('privacy.paragraph4Bullet2') }}</li>
                <li>{{ $t('privacy.paragraph4Bullet3') }}</li>
                <li>{{ $t('privacy.paragraph4Bullet4') }}</li>
            </ul>

            <p class="privacyTitles">{{ $t('privacy.titleParagraph5') }}</p>
            <p>{{ $t('privacy.paragraph5') }}</p>
            <ul>
                <li>{{ $t('privacy.paragraph5Bullet1') }}</li>
                <li>{{ $t('privacy.paragraph5Bullet2') }}</li>
                <li>{{ $t('privacy.paragraph5Bullet3') }}</li>
            </ul>

            <p class="privacyTitles">{{ $t('privacy.titleParagraph6') }}</p>
            <p>{{ $t('privacy.paragraph6') }}</p>
            <ul>
                <li>{{ $t('privacy.paragraph6Bullet1') }}</li>
                <li>{{ $t('privacy.paragraph6Bullet2') }}</li>
            </ul>
            <p>{{ $t('privacy.paragraph6B') }}</p>


            <p class="privacyTitles">{{ $t('privacy.titleParagraph7') }}</p>
            <p>{{ $t('privacy.paragraph7') }}</p>
            <ul>
                <li>
                    <span>{{ $t('privacy.paragraph7Bullet1A') }}</span>
                    <span>{{ $t('privacy.paragraph7Bullet1B') }}</span>    
                </li>
                 <li>
                    <span>{{ $t('privacy.paragraph7Bullet2A') }}</span>
                    <span>{{ $t('privacy.paragraph7Bullet2B') }}</span>    
                </li>
                 <li>
                    <span>{{ $t('privacy.paragraph3Bullet3A2') }}</span>
                    <span>{{ $t('privacy.paragraph7Bullet3B') }}</span>    
                </li>
                 <li>
                    <span>{{ $t('privacy.paragraph3Bullet4A') }}</span>
                    <span>{{ $t('privacy.paragraph7Bullet4B') }}</span>    
                </li>
                 <li>
                    <span>{{ $t('privacy.paragraph3Bullet5A') }}</span>
                    <span>{{ $t('privacy.paragraph7Bullet5B') }}</span>    
                </li>
            </ul>
            <p>{{ $t('privacy.paragraph7B') }} <span>contact@gma-logistics.com.</span></p>


            <p class="privacyTitles">{{ $t('privacy.titleParagraph8') }}</p>
            <p>{{ $t('privacy.paragraph8') }}</p>

            <p class="privacyTitles">{{ $t('privacy.titleParagraph9') }}</p>
            <p>{{ $t('privacy.paragraph9') }}</p>


            </div>
    </main>
</template>

<style scoped>
.privacy_container {
    padding-top: 120px;
}
.privacyContainer {
    margin: 10px 30px;
    text-align: start;
}
.privacyTitles {
    font-weight: 800;
    padding-top: 15px;
}
.privacySubtitles {
    font-weight: 600;
    padding-top: 8px;
}
.privacyNoMargin {
    line-height: 2px;
}

@media screen and (max-width: 750px ) {
    .privacyNoMargin{
        line-height: normal;
    }
}
</style>